import axios from 'axios'

import { TokenInfo, TokenList } from "@uniswap/token-lists";


export const getTokenList = async (url: string): Promise<Array<TokenInfo>> =>
  await axios.get<TokenList>(url).then((response) => response.data.tokens)
